module.exports = __webpack_public_path__ + "img/id-uid.e34f66b.png";